import { LINE_HEIGHT } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from './base/Text';
import InfoBox from './InfoBox';

const StatefulInfoBox = ({
  isError,
  isLoading,
  isHidden,
  customLoadingStr = '',
  customErrorStr = '',
  children
}) => {
  if (isHidden) return null;

  return (
    <Flex width='fit-content'>
      <InfoBox
        mt='small'
        mb='x-medium'
        iconAlign='center'
        iconSize='normal'
        contentDirection='row'
        backgroundColor={isError ? 'bridalHeath' : 'zircon'}
        iconColor={isError ? 'orangePeel' : 'nepal'}
      >
        <Flex color='shuttleGray' lineHeight={LINE_HEIGHT.medium}>
          {isError ? (
            <Flex>
              <Text color='black' mr='4px'>
                {customErrorStr || 'Something went wrong'}
              </Text>
              <Text color='shuttleGray'>please try again</Text>
            </Flex>
          ) : isLoading ? (
            <Text>{customLoadingStr || 'Loading...'}</Text>
          ) : (
            children
          )}
        </Flex>
      </InfoBox>
    </Flex>
  );
};

export default StatefulInfoBox;
